import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon_supplies.png'


const _withScopeId = n => (_pushScopeId("data-v-2ef3829c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middle d-flex-1f" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = { class: "d-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  })
], -1))


import { useRouter } from 'vue-router'

import runEvn from "@/modular/runEvn/RunEvn";

export default /*#__PURE__*/_defineComponent({
  __name: 'SuppliesItem',
  props: {
    itemData: Object,
    /**
     * 是否有虚线，最后一个不要
     */
    notBorder: Boolean
},
  setup(__props) {

const fileBaseUrl = runEvn().fileBaseUrl;
const router = useRouter();

const props = __props;

function goDetails() {
    router.push(`/gy/donation/details/${props.itemData.id}`);
}
const img = (key: string) => fileBaseUrl + key; 

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["warp d-flex", { 'not-border': props.notBorder }]),
    onClick: goDetails
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_van_image, {
        class: "image",
        alt: "图片加载中...",
        fit: "cover",
        src: img(props.itemData.headUrl),
        radius: "50%"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(props.itemData.userName || "匿名用户") + " ", 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(props.itemData.createTimeStamp?.format('yyyy-MM-dd HH:mm')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.itemData.suppliesName), 1),
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(props.itemData.desc?.replace(/\n/g, '')), 1)
      ])
    ]),
    _hoisted_7
  ], 2))
}
}

})